const BurgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M15 12.3262H0" stroke="black" strokeWidth="1.4" />
    <path d="M15 3.32617H0" stroke="black" strokeWidth="1.4" />
    <path d="M15 8H0" stroke="black" strokeWidth="1.4" />
  </svg>
);

export default BurgerIcon;
